module.exports = __webpack_public_path__ + "img/Akmola_obl.4eae03a8.png";